/**
 * `_id`-less value objects / config sub-trees. graphcache embeds them anyway;
 * declaring them keyless just silences the dev "Invalid key" warning and guards
 * against a future `_id` being added and silently normalized. Not exhaustive —
 * extend from any warnings the dev console logs.
 */
export const keys = {
  BookingConfig: () => null,
  UnmoderatedBookingConfig: () => null,
  SurveyBookingConfig: () => null,
  OnlineTaskBookingConfig: () => null,
  BookingStartEndSessions: () => null,
  BookingSteps: () => null,
  BookingRating: () => null,
  UserMetaType: () => null,
  UserMetaIdentityType: () => null,
  // welcome_block / thank_you_block both resolve to SystemBlock.
  SystemBlock: () => null,
  // `nodes`-only wrapper, embedded on the Query field it was fetched under.
  ParticipantBookingTaskResultsCollection: () => null,
  // The `BookingTaskResultDetails` members. The answer belongs to the result row
  // that owns it and is only ever read through it.
  BookingTaskResultDetailsCardSort: () => null,
  BookingTaskResultDetailsFigmaPrototype: () => null,
  BookingTaskResultDetailsLiveMobileTest: () => null,
  BookingTaskResultDetailsLiveWebsiteTest: () => null,
  BookingTaskResultDetailsMatrix: () => null,
  BookingTaskResultDetailsMultipleChoiceQuestion: () => null,
  BookingTaskResultDetailsOpenAnswer: () => null,
  BookingTaskResultDetailsOpinionScale: () => null,
  BookingTaskResultDetailsStackRank: () => null,
  BookingTaskResultDetailsSystemUsabilityScale: () => null,
  BookingTaskResultDetailsTreeTest: () => null,
  BookingTaskResultDetailsVariantComparison: () => null,
};
